var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "message-text" }, [
    _c("span", { domProps: { innerHTML: _vm._s(_vm.text) } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }